import {
  Button,
  DialogTitle,
  styled,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';
import IconButton from '@mui/material/IconButton';

export const FilterList = styled('ul')`
    padding-left: 25px;
`;

export const FilterListButton = styled(IconButton)`
    width: 40px;
    height: 32px;
    border-radius: 6px;
    border: none;
    padding: 0;
    margin-left: 5px;
    z-index: 2;
`;

export const FilterListButtonIcon = styled(FilterListIcon)(
  ({ theme }) => `
  fill: ${theme.palette.success.light};
`,
);

export const FilterListTable = styled(Table)`
    width: 301px;
    height: fit-content;
    display: flex;
    flex-direction: column;
    position: relative;
`;

export const FilterListHeader = styled(TableHead)`
    z-index: 2;
    width: 301px;
    height: 44px;
    display: block;
    border-bottom: none;
`;

export const FilterListTableBody = styled(TableBody)`
    display: block;
    border-bottom: none;
`;

export const FilterListHeaderRow = styled(TableRow)`
  z-index: 2;
  width: 301px;
  height: 44px;
  position: fixed;
  padding: 0;
`;

export const FilterListHeaderCell = styled(TableCell)(
  ({ theme }) => `
  z-index: 2;
  display: flex;
  flex-direction: row;
  align-items: center;
  max-width: 301px;
  padding: 10px;
  width: 100%;
  justify-content: space-between;
  background-color: ${theme.palette.grey['800']};
  border: none;
  border-radius: 3px;
  `,
);

export const FilterListTitle = styled(DialogTitle)`
    font-size: 12px;
    font-weight: 600;
    line-height: 120%;
    background: none;
    padding: 0 12px 0 3px;
`;

export const FilterListResetButton = styled(Button)`
    padding: 0 5px;
    font-weight: 600;
`;

export const FilterListInfoBox = styled(TableRow)`
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
  padding: 0;
`;

export const FilterListInfoBoxHeader = styled(TableCell)(
  ({ theme }) => `
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  max-width: 301px;
  background-color: ${theme.palette.subHeaderColor.main};
  
  &.MuiTableCell-root {
   font-weight: 600;
   font-size: 12px;
   padding: 6px 12px;
  }
`,
);

export const FilterListInfoBoxContent = styled(TableCell)`
    overflow: hidden;
    width: 100%;
    padding: 0;
`;

export const FilterListContent = styled(Typography)(
  ({ theme }) => `
  font-size: 12px;
  color: ${theme.palette.text.secondary};
`,
);

export const FilterListGroupTitle = styled(Typography)(`
  font-size: 12px;
  padding-left: 12px;
  padding-top: 12px;
`);

export const FilterListScope = styled('span')(
  ({ theme }) => `
  font-size: 12px;
  font-weight: 600;
  color: ${theme.palette.text.primary};
`,
);
